// extracted by mini-css-extract-plugin
export var aside = "loginPage-module--aside--qKjdK";
export var checkbox = "loginPage-module--checkbox--AsgGa";
export var container = "loginPage-module--container--tbQh-";
export var content = "loginPage-module--content--uMR2+";
export var logo = "loginPage-module--logo--1rpLq";
export var logos = "loginPage-module--logos--R-0MX";